export default "__VITE_ASSET__fb3cbfc2__"